<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-left">
        <a href="/" class="footer-logo-link">
          <img src="../assets/images/pabu-logo.png" alt="Pabu Logo" class="footer-logo">
        </a>
        <p class="footer-tagline">Empowering entrepreneurs with intelligent automation</p>
        <p class="footer-copyright">Copyright © 2025 - Pabu Inc.</p>
      </div>
      
      <div class="footer-right">
        <div class="footer-section">
          <h3 class="footer-section-title">Contact</h3>
          <a href="mailto:contact@pabu.ai" class="footer-link">contact@pabu.ai</a>
          <a href="https://shruthirrao.com" target="_blank" class="footer-link">Shruthi</a>
          <a href="https://vipandeepsingh.in" target="_blank" class="footer-link">Vipandeep</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent'
}
</script>

<style scoped>
.footer {
  background-color: #F5F0E8;
  width: 100%;
  padding: 3rem 2rem;
  text-align: center;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 4rem;
}

.footer-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  flex: 1;
}

.footer-logo-link {
  display: inline-block;
}

.footer-logo {
  height: 72px;
  transition: transform 0.3s ease;
}

.footer-logo:hover {
  transform: scale(1.05);
}

.footer-tagline {
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 1rem;
  color: #4A3728;
  margin: 0;
  line-height: 1.7;
}

.footer-copyright {
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 0.938rem;
  font-weight: 500;
  color: #4A3728;
  opacity: 0.7;
  margin: 0;
  margin-top: 0.5rem;
}

.footer-right {
  display: flex;
  gap: 4rem;
  flex: 1;
  justify-content: flex-end;
}

.footer-section {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  align-items: flex-start;
}

.footer-section-title {
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 1.125rem;
  font-weight: 600;
  letter-spacing: -0.01em;
  line-height: 1.3em;
  color: #4A3728;
  margin-bottom: 0.25rem;
}

.footer-link {
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 1rem;
  font-weight: 400;
  color: #4A3728;
  text-decoration: none;
  transition: opacity 0.2s ease;
  line-height: 1.7;
}

.footer-link:hover {
  opacity: 0.7;
}

/* Tablet */
@media (max-width: 1024px) {
  .footer {
    padding: 2.5rem 2rem;
  }
  
  .footer-content {
    gap: 3rem;
  }
  
  .footer-right {
    gap: 3rem;
  }
}

/* Mobile */
@media (max-width: 768px) {
  .footer {
    padding: 2.5rem 1.5rem;
    text-align: left;
  }
  
  .footer-content {
    flex-direction: column;
    gap: 2.5rem;
  }
  
  .footer-left {
    gap: 0.75rem;
  }
  
  .footer-logo {
    height: 60px;
  }
  
  .footer-tagline {
    font-size: 0.938rem;
  }
  
  .footer-right {
    justify-content: flex-start;
    gap: 2rem;
  }
  
  .footer-section-title {
    font-size: 1.0625rem;
  }
  
  .footer-link {
    font-size: 0.938rem;
  }
}

/* Extra small devices */
@media (max-width: 480px) {
  .footer {
    padding: 2rem 1rem;
  }
  
  .footer-content {
    gap: 2rem;
  }
  
  .footer-logo {
    height: 50px;
  }
  
  .footer-tagline {
    font-size: 0.875rem;
  }
  
  .footer-copyright {
    font-size: 0.875rem;
  }
  
  .footer-section-title {
    font-size: 1rem;
  }
  
  .footer-link {
    font-size: 0.875rem;
  }
}
</style>
